import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import { endOfMonth, format, startOfMonth } from "date-fns";

const defaultTake = 30;
export const useAPIgetCustomerReport = () => {
  const uiContext = useContext(UiContext);
  const { requestGetOne, requestGet, loading } = useAPIRequest();
  const [data, setData] = useState(null);
  const [error, setError] = useState({});

  const [filterValue, setFilterValue] = useState({
    search: "",
    dari_tanggal: null,
    sampai_tanggal: null,
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });

  const fetchData = async ({ page, take, filter }) => {
    if (!validate()) {
      return;
    }
    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/report`,
      params: {
        prefix: "top_spender",
        page: page,
        take: take,
        filter: newFilter,
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data: _data, message, pagination }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: newFilter,
        });
        setData(_data);
      },
    });
  };

  const getFilter = (_filterValue) => {
    const filterArr = [];
    const newFilterValue = _filterValue ?? filterValue;
    if (newFilterValue.dari_tanggal) {
      filterArr.push(
        `transaction_date:>=:${
          newFilterValue.dari_tanggal.split(" ")[0]
        } 00:00:00`
      );
    }

    if (newFilterValue.sampai_tanggal) {
      filterArr.push(
        `transaction_date:<=:${
          newFilterValue.sampai_tanggal.split(" ")[0]
        } 23:59:59`
      );
    }

    if (newFilterValue.search) {
      filterArr.push(
        `data_customer.name:contains:${newFilterValue.search}||data_customer.code:contains:${newFilterValue.search}`
      );
    }

    return filterArr.join(";");
  };

  const validate = () => {
    let isValid = true;

    const start = new Date(filterValue.dari_tanggal);
    const end = new Date(filterValue.sampai_tanggal);
    setError({});
    if (!filterValue.dari_tanggal) {
      isValid = false;
    }

    if (!filterValue.sampai_tanggal) {
      isValid = false;
    }

    if (start > end) {
      isValid = false;
      setError((prev) => ({
        ...prev,
        tanggal: "Start Date must be before End Date",
      }));
    }
    return isValid;
  };

  const handleOnClickLoad = async () => {
    fetchData({ page: 1, take: paging.take });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchData({ page: newPage, take: newTake, filter: paging.filter });
  };

  return {
    data,
    setData,
    error,
    setError,
    filterValue,
    setFilterValue,
    loading,
    handleOnClickLoad,
    handleOnPage,
    paging,
  };
};
